import TruckColorIcon from '../components/common/icons/icr_envio.svg';
import BuildColorIcon from '../components/common/icons/icr_armado.svg';
import ProductColorIcon from '../components/common/icons/icr_preparando_pedido.svg';
import CancelColorIcon from '../components/common/icons/icr_terminos.svg';
import {
  showReportIssueDispatchDate,
  showReportIssueAuthorizeThird,
  showReportIssueDispatchAddress,
} from '../constants/Visible';

export const ISSUES = [
  {
    icon: TruckColorIcon,
    title: 'Despacho y retiro',
    subtitle: 'Si tienes dudas sobre el despacho de tus compras, consúltanos.',
    disabled: false,
    id: '1',
    motives: [
      {
        id: '2',
        type: '1',
        title: 'No ha llegado mi producto',
        haveValidation: false,
        visible: 'on',
      },
      {
        id: '28',
        type: '1',
        title: 'Autorizar a un tercero a retirar mi producto',
        haveValidation: true,
        visible: showReportIssueAuthorizeThird,
      },
      {
        id: '10',
        type: '1',
        title: 'Cambiar la dirección de mi despacho',
        haveValidation: true,
        visible: showReportIssueDispatchAddress,
      },
      {
        id: '1',
        type: '1',
        title: 'Cambiar la fecha de mi despacho',
        haveValidation: true,
        visible: showReportIssueDispatchDate,
      },
      {
        id: '29',
        type: '1',
        title: 'Cobro despacho Gold/Silver',
        haveValidation: false,
        visible: 'on',
      },
    ],
  },
  {
    icon: ProductColorIcon,
    title: 'Productos',
    subtitle:
      'Si tienes inconvenientes con tu producto, déjanos tus datos y buscaremos la solución.',
    disabled: false,
    id: '2',
    motives: [
      {
        id: '6',
        title: 'Llegó en mal estado',
        type: '2',
        visible: 'on',
      },
      {
        id: '4',
        title: 'Llegó incompleto',
        type: '2',
        visible: 'on',
      },
      { id: '3', title: 'Llegó otro producto', type: '2', visible: 'on' },
      {
        id: '5',
        title: 'No funciona',
        type: '2',
        visible: 'on',
      },
      {
        id: '35',
        title: 'Cambio de producto',
        type: '2',
        haveValidation: true,
        visible: 'on',
      },
      {
        id: '37',
        type: '2',
        title: 'Producto llegó con alarma',
        haveValidation: false,
        visible: 'on',
      },
    ],
  },
  {
    icon: CancelColorIcon,
    title: 'Anular compra',
    subtitle:
      '¿Te arrepentiste de tu compra? Ingresa tus datos y nosotros gestionaremos tu anulación.',
    disabled: false,
    id: '3',
    motives: [
      {
        id: '7',
        title: 'Anular Compra',
        type: '3',
        visible: 'on',
      },
      {
        id: '11',
        title: 'Ver estado de anulación de compra',
        type: '3',
        visible: 'on',
      },
    ],
  },
  {
    icon: BuildColorIcon,
    title: 'Armar producto',
    subtitle: 'Solicita el armado de tu compra y nos comunicaremos contigo.',
    disabled: false,
    id: '5',
    motives: [
      {
        id: '9',
        title: 'Agenda tu armado',
        type: '5',
        visible: 'on',
      },
    ],
  },
];
